{
	"header": {
		"tag": "Tilisi",
		"title": "Seurattavat",
		"saved": "tallennettu"
	},
	"empty": {
		"title": "Ei tallennettuja",
		"description": "Paina sydäntä missä tahansa ilmoituksessa tallentaaksesi sen tähän.",
		"browse": "Selaa ilmoituksia"
	},
	"unavailable": "Ei enää saatavilla"
}
